import * as PropTypes from "prop-types";

import Flex from "./Flex";

import { getTileClasses } from "./shared/utils";
import { tileGroupProps } from "./shared/propTypes";

const TileGroup = ({
  className,
  count,
  dateTransform,
  dateType,
  end,
  hover,
  offset,
  start,
  step,
  tile: Tile,
  value,
  valueType,
  highlightedValue,
  productOrders = [],
  treatments,
  ...tileProps
}) => {
  const tiles = [];
  for (let point = start; point <= end; point += step) {
    const date = dateTransform(point);

    tiles.push(
      <Tile
        classes={getTileClasses({
          highlightedValue,
          value,
          valueType,
          date,
          dateType,
          hover,
        })}
        value={value}
        highlightedValue={highlightedValue}
        treatments={treatments}
        productOrders={productOrders}
        date={date}
        point={point}
        key={date.getTime()}
        {...tileProps}
      />,
    );
  }

  return (
    <Flex className={className} count={count} offset={offset} wrap>
      {tiles}
    </Flex>
  );
};

TileGroup.propTypes = {
  ...tileGroupProps,
  activeStartDate: PropTypes.instanceOf(Date),
  count: PropTypes.number,
  dateTransform: PropTypes.func.isRequired,
  offset: PropTypes.number,
  tile: PropTypes.func.isRequired,
  step: PropTypes.number,
  productOrders: PropTypes.array,
};

TileGroup.defaultProps = {
  count: 3,
  step: 1,
};

export default TileGroup;
